// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2ouPY","expandIcon":"AccordionButton_expandIcon__2QREO","expanded":"AccordionButton_expanded__3tEoR"};